import { createContext, useContext } from "react";

export interface SubNavigationPortalContextValue {
    registerPortal: (id: string, content: React.ReactNode) => void;
    unregisterPortal: (id: string) => void;
    targetElement: HTMLElement | null;
}

export const SubNavigationPortalContext =
    createContext<SubNavigationPortalContextValue | null>(null);

export const useSubNavigationPortal = () => {
    const context = useContext(SubNavigationPortalContext);
    if (!context) {
        throw new Error(
            "useSubNavigationPortal must be used within SubNavigationPortalProvider",
        );
    }
    return context;
};
